import dynamic from 'next/dynamic';
const EventFilter = dynamic(() => import('./EventFilter'));

export default EventFilter;
